<template>
  <div class="slider-container">
    <div class="slider-div">
      <input
        id="myRange"
        v-model="sliderValue"
        type="range"
        min="1"
        max="100"
        class="slider"
        @input="updateSlider(sliderValue)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeSliderSingle',
  props: {
    startValue: {
      type: Number,
      required: true
    }
  },
  emits: ['rangeSliderValue'],
  data() {
    return {
      sliderValue: null
    }
  },
  created() {
    this.sliderValue = this.startValue
  },
  methods: {
    updateSlider(value) {
      this.sliderValue = value
      this.$emit('rangeSliderValue', value)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../styles/variables';
.slider-div {
  display: flex;
  justify-content: center;
}
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  border-radius: $border-radius-small;
  background: $color-white-70;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: $color-grey-lighter;
  cursor: pointer;
  box-shadow: $box-shadow-button-and-search-field;
}
.slider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: $color-grey-lighter;
  cursor: pointer;
  box-shadow: $box-shadow-button-and-search-field;
}

@media screen and (max-width: 1024px) {
  .slider-container {
    min-width: 80px;
  }
}
</style>
